import {CLStore} from 'common/src/redux/store';
import {CompWithWorkingProps} from 'common/src/modules/movieEditor/movieEditor.types';
import {FORMAT_QUERY_KEY} from 'common/src/modules/creativeTemplates/creativeTemplates.consts';
import getUrlQueryParamValue from 'common/src/utils/urlUtils/getUrlQueryParamValue/getUrlQueryParamValue';

export default function getActiveComp(store: CLStore): CompWithWorkingProps | null {
  const state = store.getState();
  const formatMoviesState = state.creativeTemplatePage.formatMovies;

  // Get activeFormat from URL
  const activeFormat = getUrlQueryParamValue<string>(FORMAT_QUERY_KEY);

  if (!activeFormat) {
    return null;
  }

  const movies = formatMoviesState.movies;
  const activeCompId = formatMoviesState.activeCompId;

  if (!activeCompId || !movies[activeFormat]) {
    return null;
  }

  const comps = movies[activeFormat];
  const activeComp = comps[activeCompId];

  return activeComp || null;
}
